import React, { useEffect, useState } from "react";
import TagInputs from "./TagInputs";
import { IoMdClose } from 'react-icons/io'
import { post, get, put } from "../../utility/fetch";
import notification from "../../utility/notification";
import { get as getFinance } from "../../utility/fetchFinance";
import Notify from "../../utility/notify";
import { useSearchParams } from "react-router-dom";
import SpeechToTextButton from "./SpeechToTextButton";
import TextPrediction from "./TextPrediction";

const UpdateModal = ({ closeModal, modalData, other, getPatientDiagnosis, diagnosis, treatments, setRoomData, recipient, roomId, data, getRooms }) => {
    const [payload, setPayload] = useState({
        pharmacistNote: "",
        isDispensed: false
    });

    const [userNames, setUserNames] = useState([]);
    const [equipment, setEquipment] = useState([]);
    const [paymentStatus, setPaymentStatus] = useState("");


    const [searchParams] = useSearchParams();

    console.log(data)
    console.log(data?.prescriptions[0]?.medId)
    console.log(modalData);


    useEffect(() => {
        getPatientFinance();
        getPaymentStatus(modalData?.medId);

    }, [])


    const getPaymentStatus = async (id) => {
        if (id === null) {
            setPaymentStatus("-");
        }
        else {
            let res = await getFinance(`/api/patientpayment/getpaymentstatusbymedid?id=${id}`)
            console.log(res)
            if (Array.isArray(res)) {
                setPaymentStatus(res[0]?.status)
            }
            else if (res?.statusCode === 404) {
                setPaymentStatus("Not Available")
            }
            else {
                setPaymentStatus("-")
            }

        }

    }

    const administrationFrequencies = [
        { id: 1, name: 'Immediately' },
        { id: 2, name: 'As needed' },
        { id: 3, name: 'Once daily' },
        { id: 4, name: 'Twice a day' },
        { id: 5, name: 'Three times a day' },
        { id: 6, name: 'Four times a day' },
        { id: 7, name: 'At night' },
        { id: 8, name: 'Morning' },
        { id: 9, name: 'Evening' },
        { id: 10, name: 'Every 24 hours' },
        { id: 11, name: 'Every 12 hours' },
        { id: 12, name: 'Every 8 hours' },
        { id: 13, name: 'Every 6 hours' },
        { id: 14, name: 'Every 4 hours' },
        { id: 15, name: 'Every 3 hours' },
        { id: 16, name: 'Every 2 hours' },
        { id: 17, name: 'Every hour' },
        { id: 18, name: 'Every 2 months' },
        { id: 19, name: 'Every 3 months' },
    ];

    const drugStrengthUnits = [
        { id: 0, name: "Milligrams" },
        { id: 1, name: "Grams" },
        { id: 2, name: "Micrograms" },
        { id: 3, name: "Milliliters" },
        { id: 4, name: "Liters" },
        { id: 5, name: "Units" },
        { id: 6, name: "Puffs" },
        { id: 7, name: "Sprays" },
        { id: 8, name: "Drops" },
        { id: 9, name: "Patch" },
        { id: 10, name: "Bottle" },
        { id: 11, name: "TransdermalSystem" },
        { id: 12, name: "Tablet" },
        { id: 13, name: "Capsule" },
        { id: 14, name: "Suppository" },
        { id: 15, name: "Scoop" },
        { id: 16, name: "Sachet" },
        { id: 17, name: "Ampoule" },
        { id: 18, name: "Vial" },
        { id: 19, name: "InjectionPen" },
        { id: 20, name: "Enema" },
        { id: 21, name: "Ounces" },
        { id: 22, name: "Teaspoon" },
        { id: 23, name: "Tablespoon" },
        { id: 24, name: "Milliequivalents" },
        { id: 25, name: "InternationalUnits" }
    ];


    const routesOfAdministration = [
        { id: 1, name: 'Orally' },
        { id: 2, name: 'Sublingual' },
        { id: 3, name: 'Topical' },
        { id: 4, name: 'Inhalation' },
        { id: 5, name: 'Suppository' },
        { id: 6, name: 'IV' },
        { id: 7, name: 'IM' },
        { id: 8, name: 'Subcut' },
        { id: 9, name: 'Intradermal' },
        { id: 10, name: 'PerRectum' },
        { id: 11, name: 'PerVagina' },
        { id: 12, name: 'Implant' },
         { id: 13, name: "Otic" },
    { id: 14, name: "Intranasal" },
    ];


    const handleChange = (event) => {
        if (event.target.name === "equipmentId") {
            setPayload({
                ...payload,
                equipmentId: Number(event.target.value),
            })
        }
        else if (event.target.name === "patientId") {
            setPayload({
                ...payload,
                patientId: Number(event.target.value),
            })
        }
        else if (event.target.name === "quantity") {
            setPayload({
                ...payload,
                quantity: Number(event.target.value),
            })
        }
        else {
            setPayload({ ...payload, [event.target.name]: event.target.value });
        }
    }

    const update = async () => {
        let res;

        if (other) {
            res = await put(`/patient/dispense-other-prescription/${modalData?.id}`, payload);
        }
        else {
            res = await put(`/patient/dispense-prescription/${modalData?.id}`, payload);

        }
        console.log(res);
        if (res?.statusCode === 500) {
            Notify({ title: "Error", message: res?.errorData[0], type: "danger" });
            return;
        }
        else if (res?.statusCode === 400) {
            Notify({ title: "Error", message: res?.errorData[0], type: "danger" });
            return;
        }
        else if (res?.statusCode === 401) {
            Notify({ title: "Error", message: res?.errorData[0], type: "danger" });
            return;
        }
        else if (res?.statusCode === 404) {
            Notify({ title: "Error", message: res?.errorData[0], type: "danger" });
            return;
        }
        else {
            Notify({ title: "Success", message: "Prescription Updated Successfully", type: "success" });
            setPayload({
                pharmacistNote: "",
                isDispensed: false
            });
            getPatientDiagnosis(searchParams.get('id'));
            closeModal();
        }
    }

    const handleTranscript = (transcript) => {
        setPayload({ ...payload, pharmacistNote: payload?.pharmacistNote + " " + transcript });
    }




    // if (res?.statusCode === 409) {
    //     Notify({ title: "Error", message: "Equipment Already Assigned", type: "danger" });
    //     return;
    // }
    // else if (res?.statusCode === 400) {
    //     Notify({ title: "Error", message: res?.errorData[0], type: "danger" });
    //     return;
    // }
    // else if (res?.statusCode === 401) {
    //     Notify({ title: "Error", message: res?.errorData[0], type: "danger" });
    //     return;
    // }
    // else if (res?.statusCode === 404) {
    //     Notify({ title: "Error", message: res?.errorData[0], type: "danger" });
    //     return;
    // }
    // else {
    //     Notify({ title: "Success", message: "Equipment Assigned Successfully", type: "success" });
    //     setPayload({
    //         equipmentId: 0,
    //         roomId: roomId,
    //         location: "",
    //         patientId: 0,
    //         assignNote: "",
    //     });
    //     closeModal();

    // }
    // }


    const getPatientFinance = async () => {
        let res = await getFinance(`/api/patientpayment/list/patient/${data?.patientId}/1/100/patient-payment-history`);
        console.log(res);
    }



    return (
        <div className="overlay m-t-20 ">
            <IoMdClose className="close-btn pointer" onClick={() => closeModal()} />
            <div style={{ width: '80%', margin: '0 auto' }} >
                <div className=" no-padding bg-white white-bg p-20 ">
                    <div
                        className="m-t-10 p-t-10 flex-h-center modal-content-large"
                        style={{
                            boxShadow: '0px 2px 6px #0000000A',
                            // backgroundColor: 'white'
                        }}
                    >

                        <h2>
                            Prescription
                        </h2>
                        <table className="bordered-table">
                            <thead className="border-top-none">
                                <tr className="border-top-none">
                                    <th>Date</th>
                                    {/* <th>Prescribing Doctor</th> */}
                                    <th>Diagnosis</th>
                                    <th>Medication/Prescription</th>
                                    <th>Drug Strength</th>
                                    <th>Qty</th>
                                    <th>Frequency</th>
                                    <th>Route of Administration</th>
                                    <th>Duration(Days)</th>
                                    <th>Status</th>
                                    <th>Pharmacist's Note</th>
                                </tr>
                            </thead>


                            <tbody className="white-bg view-det-pane">
                                <React.Fragment key={data?.id}>
                                    <tr>
                                        <td rowSpan={data?.prescriptions?.length + 1}>
                                            {new Date(data?.dateOfVisit).toLocaleDateString()}
                                        </td>
                                        {/* <td rowSpan={data?.prescriptions?.length + 1}>{`${diagnosis?.doctor?.firstName || " N/A "} ${diagnosis?.doctor?.lastName || "N/A"}`}</td> */}
                                        <td rowSpan={data?.prescriptions?.length + 1}>{data?.diagnosis}</td>
                                        <td>{modalData?.pharmacyInventory?.productName || modalData?.name || "NIL"}</td>
                                        <td>{modalData?.pharmacyInventory?.strength || modalData?.strength || "N/A"}</td>
                                        <td>{modalData.quantity} {drugStrengthUnits.find((unit) => unit.id === modalData?.drugStrengthUnit)?.name || 'N/A'}</td>
                                        <td>{administrationFrequencies.find((freq) => freq.id === modalData.administrationFrequency)?.name || "N/A"}</td>
                                        <td>{routesOfAdministration.find((route) => route.id === modalData.routeOfAdministration)?.name || "N/A"}</td>
                                        <td>{modalData.duration} days</td>
                                        <td>{paymentStatus && (paymentStatus === "Not Paid" ? <div className="text-red">{paymentStatus}</div> : paymentStatus)}</td>
                                        <td>{modalData.pharmacistNote}</td>
                                    </tr>


                                </React.Fragment>
                            </tbody>
                        </table>

                        <h3 className="m-b-10 m-t-20">Add Note</h3>
                        {/* <TagInputs type="textArea" value={data && payload?.pharmacistNote} name="pharmacistNote" onChange={handleChange} label="Note" /> */}
                        <TextPrediction value={data && payload?.pharmacistNote} name="pharmacistNote" handleChange={handleChange} label="Note" />

                        <div className="flex">
                            <input className="m-r-10" type="checkbox" id="isDispensed" name="isDispensed" onChange={() => setPayload({
                                ...payload,
                                isDispensed: !payload?.isDispensed
                            })} checked={payload?.isDispensed} />
                            <label htmlFor="isDispensed">is Dispensed?</label>
                        </div>

                        <button disabled={(payload?.pharmacistNote?.length < 1 || paymentStatus === "Not Paid") && other === false} onClick={update} className="btn w-100 m-t-10">Submit</button>

                    </div>
                </div>
            </div>

            

        </div >
    )
}

export default UpdateModal;